import type { PaginationResponseDto } from '@goparrot/storeitems-sdk';

export const getNextPage = (lastPage: { pagination: PaginationResponseDto }, pageLimit: number): number | undefined => {
  const { total = 0, skip } = lastPage.pagination;
  const offset = skip + pageLimit;

  return offset > total ? undefined : offset;
};
